export const InvoiceStatus = {
  PENDING: 'pending',
  PAID: 'paid',
  CANCELED: 'canceled',
  FAILED: 'failed',
  PROCESSING: 'processing',
  OVERPAID: 'overpaid',
  UNDERPAID: 'underpaid'
}

export const InvoiceStatusColors = {
  PENDING: 'var(--warning)',
  PAID: 'var(--success)',
  CANCELED: 'var(--danger)',
  FAILED: 'var(--danger)',
  PROCESSING: 'var(--warning)',
  OVERPAID: 'var(--danger)',
  UNDERPAID: 'var(--danger)'
}
